/* Colour dots on visual variant options.

   Shopify only derives `option_value.swatch` from its own reserved
   `shopify--color-pattern` metaobject, which is not provisioned on this store
   and cannot be created through the API. The options ARE linked to a custom
   colour metaobject, but Horizon reads `swatch`, so it still draws word pills.
   The dot is therefore drawn here from the same palette the catalogue was
   built with. */
(function () {
  var COLOURS = {
    'gold mirror': '#C4A46B', 'silver mirror': '#CFCFCF',
    'sage & ivory': '#7D8B6F', 'blush & gold': '#EFD9D3',
    'something blue': '#7C93A8', 'black tie': '#332E2B', 'dusty blue': '#7C93A8',
    'terracotta': '#B26E4B', 'frosted': '#DDE3E1', 'silver': '#C9C9C9',
    'merlot': '#7A3B47', 'blush': '#EFD9D3', 'amber': '#C08A3E',
    'ivory': '#FBF8F3', 'clear': '#E8ECEA', 'white': '#FFFFFF',
    'black': '#332E2B', 'sage': '#7D8B6F', 'gold': '#B99668'
  };
  // longest first, so "gold mirror" wins over "gold"
  var NAMES = Object.keys(COLOURS).sort(function (a, b) { return b.length - a.length; });
  var VISUAL = ['finish', 'colour', 'color', 'palette', 'glass'];

  var observer = null;

  function colourFor(label) {
    var raw = (label.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!raw) return null;
    for (var i = 0; i < NAMES.length; i++) {
      // the selected pill appends hidden state text, so match on the prefix
      if (raw === NAMES[i] || raw.indexOf(NAMES[i]) === 0) return COLOURS[NAMES[i]];
    }
    return null;
  }

  function decorate() {
    document.querySelectorAll('variant-picker fieldset').forEach(function (set) {
      var legend = set.querySelector('legend');
      if (!legend) return;
      var name = legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase().split(':')[0].trim();
      if (VISUAL.indexOf(name) === -1) return;

      set.querySelectorAll('label').forEach(function (label) {
        if (label.querySelector('.sv-dot')) return;
        var hex = colourFor(label);
        if (!hex) return;
        var dot = document.createElement('span');
        dot.className = 'sv-dot';
        dot.style.background = hex;
        dot.setAttribute('aria-hidden', 'true');
        label.insertBefore(dot, label.firstChild);
      });
    });
  }

  function run() {
    // pause the observer so our own insertions do not retrigger it
    if (observer) observer.disconnect();
    decorate();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    observer = new MutationObserver(function () {
      window.clearTimeout(observer._t);
      observer._t = window.setTimeout(run, 120);
    });
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
